<div class="box box-white has-shadow">
    <div class="box-header box-body">

        <div class="box-header-icon">
            <i class="icon-customer"></i>
        </div>

        <div class="box-header-title">
            {{ 'OFFER_CONFIG.CLIENTS' | translate }}
        </div>
    </div>

    <div class="box-content">
        <div class="box-body">
            <ng-container *ngFor="let person of partyList; let index = index">

                <div class="box-row has-padding">
                    <div class="box-item">
                        <div class="row">
                            <div class="mobile col-3">
                                <app-output [label]="personLabel(person) | translate">
                                    {{ person.fullName }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.companyNumber">
                                <app-output [label]="'LABEL.COMPANY_NUMBER' | translate">
                                    {{ person.companyNumber }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.companyCountry">
                                <app-output [label]="'LABEL.COMPANY_COUNTRY' | translate">
                                    {{ person.companyCountry.description }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.pesel">
                                <app-output [label]="'LABEL.PESEL' | translate">
                                    {{ person.pesel }}
                                </app-output>
                            </div>
                            <div class="mobile col-3">
                                <app-output [label]="personAddressLabel(person) | translate">
                                    {{ person.mainAddress.fullAddress }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.otherCorrespondenceAddress">
                                <app-output [label]="'LABEL.ADDRESS_CORESPONDENCE' | translate">
                                    {{ person.correspondenceAddress.fullAddress }}
                                </app-output>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-row has-padding" *ngIf="person.birthDate || person.gender || person.documentType || person.documentNumber || person.citizenship">
                    <div class="box-item">
                        <div class="row">
                            <div class="mobile col-3" *ngIf="person.birthDate">
                                <app-output [label]="'LABEL.DATE_OF_BIRTH' | translate">
                                    {{ person.birthDate | lsnDate }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.gender">
                                <app-output [label]="'LABEL.GENDER' | translate">
                                    {{ person.gender.description }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.citizenship">
                                <app-output [label]="'LABEL.CITIZENSHIP' | translate">
                                    {{ person.citizenship.description }}
                                </app-output>
                            </div>
                            <div class="mobile col-3" *ngIf="person.documentType || person.documentNumber">
                                <app-output [label]="('LABEL.DOCUMENT_TYPE' | translate) + ' / ' + ('LABEL.DOCUMENT_NUMBER' | translate)">
                                    {{ person.documentType.description }} / {{ person.documentNumber }}
                                </app-output>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="box-row" *ngIf="!readonly && index === 0">
                    <ng-container *ngIf="emptyContactData">
                        <div class="separator"></div>

                        <app-alert alertType="info" class="w-100">
                            {{ 'INFO.ADD_CONTACT_DATA' | translate }}
                        </app-alert>
                    </ng-container>
                </div>


                <ng-container *ngIf="person.id === policyholderId">
                    <div class="box-row  has-bottom-border"
                         *ngIf="!readonly && !document.additionalData.hasContactData">
                        <div class="box-item text-accent">
                            <button class="btn btn-link btn-slim" type="button" (click)="editContactData()">
                                <i class="icon-add mr-2"></i>
                                <span>{{'BUTTON.ADD_CONTACT_DATA' | translate}}</span></button>
                        </div>
                    </div>

                    <div class="box-row has-padding" *ngIf="document.additionalData.hasContactData">
                        <div class="box-item">
                            <div class="w-100">
                                <div class="row">
                                    <div class="col">
                                        <h3 class="mb-3">{{'CONTACT_DATA' | translate}}</h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mobile col-3">
                                        <app-output [label]="'LABEL.PHONE_NUMBER' | translate">
                                            {{ phoneNumber }}
                                        </app-output>
                                    </div>

                                    <div class="mobile col" *ngIf="document.additionalData.contactData.email">
                                        <app-output [label]="'LABEL.EMAIL' | translate">
                                            {{ document.additionalData.contactData.email }}
                                        </app-output>
                                    </div>

                                    <div class="col-auto align-self-center justify-content-end"
                                         *ngIf="!readonly">
                                        <button class="btn btn-link btn-slim"
                                                (click)="deleteContactData()"
                                                [matTooltip]="'BUTTON.DELETE_CONTACT_DATA' | translate">
                                            <i class="icon-delete mr-1"></i>
                                        </button>
                                        <button class="btn btn-link btn-slim"
                                                [matTooltip]="'BUTTON.EDIT_CONTACT_DATA' | translate"
                                                (click)="editContactData()">
                                            <i class="icon-edit"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
